export default __webpack_public_path__ + "static/media/Domine-VariableFont_wght.3b057369.ttf";